import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/Home";
import About from "./components/About";
import Projects from "./components/Projects";
import axios from "axios";
import Contact from "./components/Contact";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { withStyles } from "@material-ui/core/styles";
import Footer from "./components/Footer";
import { apiURL } from "./util/config";
import Admin from "./components/Admin";
import Views from "./components/Views";
import projects from "./components/data";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.prevPath = "";

    let i = 1;
    projects.forEach(p => {
      p.id = i;
      i++;
    });

    this.state = {
      projects: projects
    };
  }

  async componentDidMount() {
    /*await axios.get(apiURL+"/Project/GetAll", {})
    .then((res) => {
        let i = 1;
        res.data.forEach(p => {
          p.id = i;
          i++;
        });


        this.setState({projects: res.data});
    })
    .catch(function (error) { 
        console.log('error getting projects: ', error);
    });


    axios.post(apiURL+"/View/Create").then((res) => {

    }).catch((error) => {
      console.log('error sending view stat');
    });*/
  }

  render() {
    //const { projects } = this.state;
    const { classes } = this.props;

    const childFactoryCreator = props => child =>
      React.cloneElement(child, props);

    const routes = ["/", "/about", "/projects", "/contact"];

    const getRouteId = route => {
      for (let i = 0; i < routes.length; i++) {
        if (routes[i] === route) {
          return i;
        }
      }
      return routes.length;
    };

    return (
      <Router>
        <Route
          render={({ location, history }) => {
            const direction =
              getRouteId(location.pathname) < getRouteId(this.prevPath)
                ? "LEFT"
                : "RIGHT";

            const transition = location.pathname !== this.prevPath;

            this.prevPath = location.pathname;

            return (
              <Layout>
                <TransitionGroup
                  className={classes.transition}
                  childFactory={childFactoryCreator({
                    classNames: {
                      enter:
                        direction === "RIGHT"
                          ? classes.fadeRightEnter
                          : classes.fadeLeftEnter,
                      enterActive:
                        direction === "RIGHT"
                          ? classes.fadeRightEnterActive
                          : classes.fadeLeftEnterActive,
                      exit:
                        direction === "RIGHT"
                          ? classes.fadeRightExit
                          : classes.fadeLeftExit,
                      exitActive:
                        direction === "RIGHT"
                          ? classes.fadeRightExitActive
                          : classes.fadeLeftExitActive
                    },
                    timeout: 500
                  })}
                >
                  <CSSTransition key={location.pathname} timeout={500}>
                    <section className={classes.routeSection}>
                      <Switch location={location}>
                        <Route
                          exact
                          path="/"
                          render={props => <Home {...props} {...this.state} />}
                        />
                        <Route path="/about" component={About} />
                        <Route
                          exact
                          path="/projects"
                          render={props => (
                            <Projects {...props} {...this.state} />
                          )}
                        />
                        <Route
                          path="/projects/:id"
                          render={props => (
                            <Projects {...props} {...this.state} />
                          )}
                        />
                        <Route path="/contact" component={Contact} />
                        <Route
                          exact
                          path="/admin"
                          render={props => <Admin {...props} {...this.state} />}
                        />
                        <Route path="/views" component={Views} />
                      </Switch>
                      <div className={classes.footer}>
                        <Footer />
                      </div>
                    </section>
                  </CSSTransition>
                </TransitionGroup>
              </Layout>
            );
          }}
        />
      </Router>
    );
  }
}
const styles = theme => ({
  fadeLeftEnter: {
    transform: "translate(-100%)"
  },
  fadeLeftEnterActive: {
    transform: "translate(0%)",
    transition: "transform 500ms ease-in-out"
  },
  fadeLeftExit: {
    transform: "translate(0%)",
    opacity: "1"
  },
  fadeLeftExitActive: {
    transform: "translate(100%)",
    opacity: "0.01",
    transition: "transform 500ms ease-in-out, opacity 500ms ease-in"
  },
  fadeRightEnter: {
    transform: "translate(100%)"
  },
  fadeRightEnterActive: {
    transform: "translate(0%)",
    transition: "transform 500ms ease-in-out"
  },
  fadeRightExit: {
    transform: "translate(0%)",
    opacity: "1"
  },
  fadeRightExitActive: {
    transform: "translate(-100%)",
    opacity: "0.01",
    transition: "transform 500ms ease-in-out, opacity 500ms ease-in"
  },
  transition: {
    position: "relative"
  },
  routeSection: {
    position: "absolute",
    width: "100%",
    top: "0",
    left: "0",
    minHeight: "calc(100vh - " + theme.spacing.unit * 8 + "px)",
    paddingBottom: theme.spacing.unit * 15
  },
  footer: {
    position: "absolute",
    bottom: 0,
    width: "100%"
  }
});
/*
const styles = theme => ({

  fadeEnter: {
    opacity: '0.01',
  },
  fadeEnterActive: {
    opacity: '1',
    transition: 'opacity 300ms ease-in'
  },
  fadeExit :{
      opacity: '1'
  },
  fadeExitActive: {
      opacity: '0.01',
      transition: 'opacity 300ms ease-in'
  },
  transition: {
    position: 'relative',
  },
  routeSection: {
    position: 'absolute',
    width: '100%',
    top: '0',
    left: '0',
  },
  layout: {
    height: 'auto'
  }

});*/

export default withStyles(styles)(App);
